import { BillVoidedEvent } from '@rematter/frontend-lib-api-client/grpc/finance/v1/bill_events_pb';
import { BillStatus } from '@rematter/frontend-lib-api-client/grpc/finance/v1/domain_pb';
import { Col, FieldDisplay, StatusTransition } from '@rematter/ui-web';

import { billStatusLabels, billTypeLabels } from '../enumLabels';

import { useTranslations } from '@/finance/i18n/useTranslations';

type BillVoidedDetailProps = {
  event: BillVoidedEvent;
};

export const BillVoidedDetail = ({ event }: BillVoidedDetailProps) => {
  const t = useTranslations();
  const bill = event.bill;
  const previousStatus = event.previousStatus;

  if (!bill) {
    return (
      <Col className="@BillVoidedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  const formatAmount = () => {
    if (!bill.amount) return 'N/A';
    const value = Number(bill.amount.amount) / 100;
    return `${bill.amount.currency} ${value.toFixed(2)}`;
  };

  return (
    <Col className="@BillVoidedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.bill}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay label="Document Number" value={bill.documentNumber} />
          <FieldDisplay label="Type" value={billTypeLabels[bill.type]} />
          <FieldDisplay label="Amount" value={formatAmount()} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.statusChange}
        </span>
        <StatusTransition
          previousStatus={billStatusLabels[previousStatus]}
          newStatus={billStatusLabels[BillStatus.VOIDED]}
        />
      </Col>
    </Col>
  );
};
